const mapHandler = (context, scene, hasLightstick = false, x = 15, y = 15) => {
    const map = context.make.tilemap({ key: scene });

    let noLightstickTileset = null;

    if(hasLightstick) {
        noLightstickTileset =  map.addTilesetImage(`noLightstick-${scene}`, `noLightstick${scene}`, x, y);
    }

    let tileset =  map.addTilesetImage(scene, `tiles${scene}`, x, y);

    const ground = map.createLayer('Ground', hasLightstick ? noLightstickTileset : tileset, 0, 0)
    const walls = map.createLayer('Walls', tileset, 0,0);

    walls.setCollisionByProperty({ collides: true });

    return { walls, map, ground, tileset };
};

const walkAnimation = (context, character, isSpider = false) => {

    if(isSpider) {
        context.anims.create({
            key: `left-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 3, end: 5 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `up-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 9, end: 11 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `down-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 0, end: 2 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `right-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 6, end: 8 }),
            frameRate: 7,
            repeat: -1
        });
    } else {
        context.anims.create({
            key: `left-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 0, end: 3 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `up-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 13, end: 16 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `down-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 9, end: 12 }),
            frameRate: 7,
            repeat: -1
        });
    
        context.anims.create({
            key: `right-${character}`,
            frames: context.anims.generateFrameNumbers(character, { start: 5, end: 8 }),
            frameRate: 7,
            repeat: -1
        }); 
    }
};

const reposeAnimation = (context, character) => {
    context.anims.create({
        key: `repose-${character}`,
        frames: context.anims.generateFrameNumbers(character, { start: 17, end: 19 }),
        frameRate: 5,
        repeat: -1
    });
};

const turnStaticAnimation = (context, character, frame = 4) => {
    context.anims.create({
        key: `turn-${character}`,
        frames: [ { key: character, frame: frame } ],
        frameRate: 20
    });
};

const upStaticAnimation = (context, character, frame = 14) => {
    context.anims.create({
        key: `up-static-${character}`,
        frames: [ { key: character, frame: frame } ],
        frameRate: 20
    });
};

const leftStaticAnimation = (context, character, frame = 1) => {
    context.anims.create({
        key: `left-static-${character}`,
        frames: [ { key: character, frame: frame } ],
        frameRate: 20
    });
};

const rightStaticAnimation = (context, character, frame = 6) => {
    context.anims.create({
        key: `right-static-${character}`,
        frames: [ { key: character, frame: frame } ],
        frameRate: 20
    });
};

const backStaticAnimation = (context, character, frame = 11) => {
    context.anims.create({
        key: `back-${character}`,
        frames: [ { key: character, frame: frame } ],
        frameRate: 20
    });
};

const lightstickAnimation = (context, character, start = 20, end = 22) => {
    context.anims.create({
        key: `lightstick-${character}`,
        frames: context.anims.generateFrameNumbers(character, { start, end}),
        frameRate: 5,
        repeat: -1
    });
};

module.exports = {
    mapHandler,
    walkAnimation,
    reposeAnimation,
    turnStaticAnimation,
    upStaticAnimation,
    leftStaticAnimation,
    rightStaticAnimation,
    backStaticAnimation,
    lightstickAnimation
};